import axios from 'axios';
import { useService } from '../common/useService';
import Order from './Order';

const useGetUserLastOrder = () =>
  useService((userId: number) => {
    return axios.post<Order>('/my-account-api/order/get-last-order-by-user-id.php', { userId });
  });

const OrderService = {
  useGetUserLastOrder,
};

export default OrderService;
